import HouseLocation from "../../images/location-house.svg";
import ZagsLocation from "../../images/location-zags.svg";

const Maps = () => {
    return (
        <section className="maps-section" >
            <h2 className="margin-none fs-24 fw-500" >Место проведения</h2>
            <div className="adress" >
                <div className="adress__title">
                    <img alt="location-house" src={HouseLocation} />
                    <h3 className="margin-none fw-500">Коттедж "House in Dibun"</h3>
                </div>
                <p className="adress__adress mx-auto">Адрес: <i>Санкт-Петербург, пос. Песочный, ул. Пограничная, дом 97</i></p>
                <div className="maps-block">
                    <iframe className="maps-block__map" src="https://yandex.ru/map-widget/v1/?um=constructor%3A29694658c23443a82b7e3e57fd367697500da346375611f476df051b3f301000&amp;source=constructor" width="320" height="240" frameborder="0"></iframe>
                    <div className="maps-block__text" >
                        <p className="margin-none">Для вашего удобства, добраться до нашего свадебного коттеджа проще всего на <b className="fw-600">электричке</b>.</p>
                        <p className="margin-none">Возьмите поезд с <b className="fw-600">Финляндского вокзала</b> в направлении <b className="fw-600">Рощино</b>. Ваша станция – <b className="fw-600">Дибуны</b>.</p>
                        <p className="margin-none">Отсюда всего 15 минут пешком, и вы у цели! Мы будем ждать вас там.</p>
                    </div>
                </div>
            </div>
            <div className="background-gradient"></div>
        </section>
    );
};

export default Maps;